module.exports = __webpack_public_path__ + "static/media/main idea.ef40c618.mp3";